import * as React from "react";
import { StateSelectField, TextField } from "components";

import { EditDebtorType } from "./types";

interface PropsType {
  debtor: EditDebtorType;
  onFieldBlur(): void;
  onFieldChange(e: { currentTarget: { name: string; value: string } }): void;
}

export default function AddressInfo(props: PropsType): JSX.Element {
  const { debtor, onFieldBlur, onFieldChange } = props;

  return (
    <section className="address-info">
      <div className="form--fieldset">
        <div className="content">
          <header>
            <div className="badge">
              <i className="fas fa-map-marker-alt" />
            </div>

            <h3>Address</h3>
          </header>

          <div className="body">
            <div className="form--field-group">
              <TextField
                label="Street"
                name="street1"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                required
                value={debtor.street1}
              />

              <TextField
                label="Apt/Suite (optional)"
                name="street2"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                value={debtor.street2}
              />
            </div>

            <TextField
              label="City"
              name="city"
              onBlur={onFieldBlur}
              onChange={onFieldChange}
              required
              value={debtor.city}
            />

            <div className="state-zip">
              <StateSelectField
                label="State"
                name="state"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                value={debtor.state}
              />

              <TextField
                label="Zip"
                name="zip"
                onBlur={onFieldBlur}
                onChange={onFieldChange}
                required
                value={debtor.zip}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
